import {
    userProfileConstants,
    userProfileFulfilledConstants,
    userProfileRejectedConstants,
    userProfilePendingConstants,
    devicesFulfilledConstants,
    devicesPendingConstants,
    devicesRejectedConstants
} from '../actions';

const initialState = {
    userName: '',
    userInfo: {
        id: null,
        locationId: null,
        locationName: '',
        officeId: null,
        officeName: '',
        userName: '',
        office: null
    },
    equipment: {
        licenses: [],
        devices: [],
        mobileDevices: []
    },
    isLoading: false,
    error: ''
};

export default function (state = initialState, action) {
    switch (action.type) {
        case userProfileConstants.USER_DATA_CLEARED:
            return { ...initialState, userInfo: state.userInfo };
        case userProfilePendingConstants.USER_DATA_LOADED:
            return {
                ...state,
                equipment: {
                    ...state.equipment,
                    loading: true,
                },
                isLoading: true
            };
        case userProfileFulfilledConstants.USER_DATA_LOADED:
            return {
                ...state,
                userName: action.payload.userName,
                equipment: {
                    ...action.payload.equipment,
                    loading: false,
                },
                isLoading: false
            };
        case userProfilePendingConstants.USER_INFO_LOADED:
            return {
                ...state,
                isLoading: true
            };
        case userProfileFulfilledConstants.USER_INFO_LOADED:
            return {
                ...state,
                userInfo: action.payload,
                isLoading: false,
            };
        case userProfilePendingConstants.USER_FIND_DATA_LOADED:
            return {
                ...state,
                isLoading: true
            };
        case userProfileFulfilledConstants.USER_FIND_DATA_LOADED:
            return {
                ...state,
                equipment: action.payload.equipment,
                userName: action.payload.userName,
                isLoading: false,
            };
        case userProfileRejectedConstants.USER_DATA_LOADED:
            return {
                ...state,
                equipment: {
                    ...state.equipment,
                    loading: false,
                },
                error: `${action.payload.response.data.errorMessage || action.payload.response.status + ' ' + action.payload.response.statusText}`,
                isLoading: false,
            };
        case userProfileRejectedConstants.USER_INFO_LOADED:
            return {
                ...state,
                error: `${action.payload.response.data.errorMessage || action.payload.response.status + ' ' + action.payload.response.statusText}`,
                isLoading: false,
            };
        case devicesFulfilledConstants.DEVICE_PROFILE_INFO_LOADED:
            const { data, deviceId } = action.payload;
            return {
                ...state,
                equipment: {
                    ...state.equipment,
                    devices: state.equipment.devices.map(item => (item.id === deviceId ? { ...item, profileData: data, isLoading: false, error: '' } : item)),
                },
                isLoading: false,
            };
        case devicesPendingConstants.DEVICE_PROFILE_INFO_LOADED:
            return {
                ...state,
                equipment: {
                    ...state.equipment,
                    devices: state.equipment.devices.map(item => (item.id === action.meta ? { ...item, profileData: { isLoading: true, error: '' } } : item)),
                },
                isLoading: true
            };
        case devicesRejectedConstants.DEVICE_PROFILE_INFO_LOADED:
            const error = action.payload;

            return {
                ...state,
                equipment: {
                    ...state.equipment,
                    devices: state.equipment.devices.map(item =>
                        (item.id === action.meta
                            ? { ...item, profileData: { isLoading: false, error: error.message } }
                            : item
                        )),
                },
                isLoading: false,
            };
        default:
            return state;
    }
}
